import React, { useState } from 'react'
import TourModal from './TourModal'

const Tour = () => {
    const [isTourModalOpened, setIsTourModalOpened] = useState(false)

    const handleOpenModal = () => {
        setIsTourModalOpened(true)
    }

    return (
        <>
            <div className="start-tour-link" onClick={handleOpenModal}>
                <i className="ri-question-line"></i>
            </div>
            {isTourModalOpened && <TourModal onClose={() => setIsTourModalOpened(false)} />}
        </>
    )
}

export default Tour
